






























































































































































































import { Component, Vue } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'
import FinanceiroStore from '@/components/RemuneracaoMedica/financeiro/Store/FinanceiroStore'
import EventBus from '@/plugins/EventBus'
import ResponseApi from '@/types/interfaces/FactoryResponse'


@Component
export default class ComponentModalFiltroDownloadNotasFiscais extends Vue {
  loadEmitirRelatorio: boolean = false
  menuAnoMesReferencia: boolean = false
  menuDe: boolean = false
  menuAte: boolean = false

  // Filtros de GERAÇÃO do lote: estado local, não do store. A listagem (drawer "Filtros
  // avançados") usa as variáveis homônimas do FinanceiroStore; enquanto a modal também
  // escrevia lá, limpar um campo aqui destruía o filtro da listagem e vice-versa.
  filtroAnoMes: string = ''
  filtroFontePagadora: string = ''
  filtroGrupoRepasse: string = ''
  filtroSituacao: string = ''
  filtroDe: string = ''
  filtroAte: string = ''

  $refs!: {
    menuAnoMesReferencia: any,
    menuDe: any,
    menuAte: any,
  }

  get modalFiltroDownloadNotaFiscal() { return this.getFinanceiroStore.modal.filtroDownloadNotaFiscal }
  set modalFiltroDownloadNotaFiscal(value: boolean) { this.getFinanceiroStore.setModal({ name: 'filtroDownloadNotaFiscal', value }) }

  get getFinanceiroStore() {
    return getModule(FinanceiroStore, this.$store)
  }

  get loadingNotaFiscal() {
    return this.loadEmitirRelatorio
  }

  set loadingNotaFiscal(value: boolean) {
    this.loadEmitirRelatorio = value
  }

  get getMenuAnoMesReferencia() {
    return this.menuAnoMesReferencia
  }

  set getMenuAnoMesReferencia(value: boolean) {
    this.menuAnoMesReferencia = value
  }

  get getMenuDe() {
    return this.menuDe
  }

  set getMenuDe(value: boolean) {
    this.menuDe = value
  }

  get getMenuAte() {
    return this.menuAte
  }

  set getMenuAte(value: boolean) {
    this.menuAte = value
  }

  get possuiAlgumFiltro() {
    return !!(this.filtroAnoMes || this.filtroFontePagadora || this.filtroGrupoRepasse
      || this.filtroSituacao || this.filtroDe || this.filtroAte)
  }

  get getFontePagadorasDownloadNotasFiscais() {
    return this.getFinanceiroStore.fontePagadoras
  }

  set getFontePagadorasDownloadNotasFiscais(value: any[]) {
    this.getFinanceiroStore.setFontePagadora(value)
  }

  get getGrupoRepassesDownloadNotasFiscais() {
    return this.getFinanceiroStore.grupoRepasseItensAll
  }

  set getGrupoRepassesDownloadNotasFiscais(value: any[]) {
    this.getFinanceiroStore.setGrupoRepasseItensAll(value)
  }

  get getSituacoesDoRepasseDownloadNotasFiscais() {
    return [
      { key: 'Todos', display: 'Todos' },
      { key: 'Pendente', display: 'Pendente' },
      { key: 'Divergente', display: 'Divergente' },
      { key: 'Provisionada', display: 'Provisionada' },
      { key: 'ValidacaoPendente', display: 'Validação pendente' },
      { key: 'Validada', display: 'Validada' },
      { key: 'Paga', display: 'Paga' },
      { key: 'EnviadoParaPagamento', display: 'Enviado para pagamento' },
    ]
  }

  limparFiltros() {
    this.filtroAnoMes = ''
    this.filtroFontePagadora = ''
    this.filtroGrupoRepasse = ''
    this.filtroSituacao = ''
    this.filtroDe = ''
    this.filtroAte = ''
  }

  closeModalFiltroDownloadNotaFiscal() {
    this.limparFiltros()
    this.modalFiltroDownloadNotaFiscal = false
  }

  formatDate(date: string) {
  // eslint-disable-next-line
    if (!date || isNaN(Date.parse(date))) return ''
    const [year, month, day] = date.split('-')
    return `${day}-${month}-${year}`
  }

  async filtroDownloadNotaFiscal() {
    this.loadingNotaFiscal = true
    let response: ResponseApi<any> | any = {}

    // Ano/mês referência deixou de ser obrigatório: é possível baixar pelo período de upload,
    // independente da competência do repasse. Exige-se ao menos um filtro redutor (espelha o backend).
    const semFiltro = !this.filtroAnoMes
      && !this.filtroFontePagadora
      && !this.filtroGrupoRepasse
      && !this.filtroDe
      && !this.filtroAte

    if (semFiltro) {
      EventBus.$emit('setSnackbar', { show: true, text: 'Informe ao menos um filtro: ano/mês de referência, fonte pagadora, grupo de repasse ou uma janela de datas de upload.', icon: 'warning', color: '#C62828' })
      this.loadingNotaFiscal = false
      return
    }

    response = await this.getFinanceiroStore.filtroDownloadNotaFiscal({
      anoMesReferencia: this.filtroAnoMes ? `${this.filtroAnoMes}-01` : null,
      fontePagadoraId: this.filtroFontePagadora || null,
      grupoRepasseId: this.filtroGrupoRepasse || null,
      createdOnNFDe: this.filtroDe || null,
      createdOnNFAte: this.filtroAte || null,
      status: this.filtroSituacao || null,
    })

    if (response.success) {
      EventBus.$emit('setSnackbar', { show: true, text: 'Solicitação enviada! O lote está sendo gerado e aparecerá na lista como concluído em instantes.', icon: 'done', color: '#2E7D32' })
      // Volta à 1ª página, onde o lote recém-criado aparece (ordenação é por CreatedOn DESC).
      // Os filtros da listagem são do usuário e não são tocados aqui - a modal tem estado próprio.
      this.getFinanceiroStore.setPagina(1)
      await this.getFinanceiroStore.getItemsDownloadNotasFiscais()
      // Avisa a listagem para começar a acompanhar a geração sem depender do watcher.
      EventBus.$emit('notaFiscalLoteGerado')
      this.closeModalFiltroDownloadNotaFiscal()
    } else {
      if (response.errors && response.errors.length > 0) {
        const errorMessage = response.errors[0].message || 'Ocorreu um erro ao realizar o download.'
        EventBus.$emit('setSnackbar', { show: true, text: errorMessage, icon: 'warning', color: '#C62828' })
      } else {
        const mainMessage = response.message || 'Ocorreu um erro ao realizar o download.'
        EventBus.$emit('setSnackbar', { show: true, text: mainMessage, icon: 'warning', color: '#C62828' })
      }
      this.loadingNotaFiscal = false
    }
    this.loadingNotaFiscal = false
  }
}
